import { render } from "./MaterialStockListingsEditor.vue?vue&type=template&id=106806d5&scoped=true"
import script from "./MaterialStockListingsEditor.vue?vue&type=script&lang=js"
export * from "./MaterialStockListingsEditor.vue?vue&type=script&lang=js"

import "./MaterialStockListingsEditor.vue?vue&type=style&index=0&id=106806d5&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-106806d5"]])

export default __exports__